const PaymentForm = {
    item: {},
    isFetching:false
}

const initialState = {
    PaymentForm,
}

export default initialState;
